export enum TaskTriggerCallTypes {
  MANUAL = 'Manual',
  AUTOMATIC = 'Automatic'
}
